export default "__VITE_ASSET__93f3a57e__"